<div class="dnd-wrapper" #parent>
  <div class="flex items-center gap-0.5 py-1">
    @if (state.nodes.length > 1) {
      <div class="dnd-items-counter">{{ state.nodes.length }}</div>
    }
    @if (state.notAllowedReason) {
      <div class="dnd-not-allowed-message">
        <dojo-icon [icon]="'ban'" class="mr-1" />
        @switch (state.notAllowedReason) {
          @case (NotAllowedReason.NotAllowedToBeMoved) {
            <span>
              {{ nodes.length > 1 ? "Items can't be moved" : "Item can't be moved" }}
            </span>
          }
        }
      </div>
    }
  </div>
  @for (node of state.nodes; track node.path) {
    @if ($index < 5) {
      <div class="dnd-item" [class.excessive-dnd-items]="$index > 4" [class.not-allowed]="state.notAllowedReason">
        <span class="text">{{ node.uiName }}</span>
      </div>
    }
  }
</div>
